import LinkCTA from '2-core-elements/LinkCTA/LinkCTA';
import type { FC } from 'react';
import { useDonorBlockProps } from '../DonorDetailProvider';

const PrivacyLink: FC = () => {
    const { privacyLink } = useDonorBlockProps();

    if (!privacyLink?.enable) {
        return null;
    }

    const isOpenNewTab = privacyLink.openNewTab;

    return (
        <div className="donor-privacy-link-wrapper">
            <LinkCTA href={privacyLink.linkUrl} suffixIcon={`arrow-right-slim`} size={'md'} target={isOpenNewTab ? '_blank' : '_self'}>{privacyLink.linkText}</LinkCTA>
        </div>
    );
};

export default PrivacyLink;
